(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wyse-header"]) return;
  try {
    
function initWyseNav(root=document){
root.querySelectorAll('[data-wyse-header]').forEach(header=>{
if(header.dataset.ready)return;header.dataset.ready='true';
const toggle=header.querySelector('.wyse-nav-toggle');
const close=()=>{header.dataset.navOpen='false';toggle.setAttribute('aria-expanded','false');header.querySelectorAll('details').forEach(d=>d.open=false)};
close();toggle.addEventListener('click',()=>{const open=header.dataset.navOpen!=='true';header.dataset.navOpen=String(open);toggle.setAttribute('aria-expanded',String(open))});
header.addEventListener('keydown',e=>{if(e.key==='Escape'){const group=e.target.closest('details');if(group?.open){group.open=false;group.querySelector('summary').focus()}else{close();toggle.focus()}}});
header.querySelectorAll('details').forEach(group=>group.addEventListener('toggle',()=>{if(group.open)header.querySelectorAll('details').forEach(other=>{if(other!==group)other.open=false})}));
document.addEventListener('click',e=>{if(!header.contains(e.target))close()});
});
}
initWyseNav();document.addEventListener('shopify:section:load',e=>initWyseNav(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wyse-nfl-preview"] && !Shopify.designMode) return;
  try {
    
function initWyseNFL(root = document) {
  root.querySelectorAll('.wyse-nfl').forEach(section => {
    if (section.dataset.nflReady) return;
    section.dataset.nflReady = 'true';
    const dialog = section.querySelector('[data-nfl-dialog]');
    section.querySelectorAll('[data-nfl-zoom]').forEach(link => link.addEventListener('click', event => {
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      const image = dialog.querySelector('img');
      ['srcset', 'sizes', 'width', 'height'].forEach(attribute => image.removeAttribute(attribute));
      image.src = link.href;
      image.alt = link.dataset.nflAlt || '';
      dialog.showModal();
      dialog.addEventListener('close', () => link.focus(), {once:true});
    }));
    const search = section.querySelector('[data-nfl-search]');
    search?.addEventListener('input', () => {
      const query = search.value.trim().toLowerCase();
      let visible = 0;
      section.querySelectorAll('[data-nfl-team]').forEach(team => {
        const match = team.dataset.nflTeam.includes(query);
        team.hidden = !match;
        if (match) visible++;
      });
      section.querySelector('[data-nfl-empty]').hidden = visible > 0;
      section.querySelector('[data-nfl-count]').textContent = visible + (visible === 1 ? ' team' : ' teams');
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initWyseNFL());
else initWyseNFL();
document.addEventListener('shopify:section:load', event => initWyseNFL(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wyse-nfl-team"] && !Shopify.designMode) return;
  try {
    
function initWyseTeam(root=document){root.querySelectorAll('.wyse-team').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const dialog=section.querySelector('dialog');section.querySelectorAll('[data-team-zoom]').forEach(link=>link.addEventListener('click',e=>{if(!dialog?.showModal)return;e.preventDefault();const image=dialog.querySelector('img');['srcset','sizes','width','height'].forEach(attribute=>image.removeAttribute(attribute));image.src=link.href;image.alt=link.dataset.teamAlt||'';dialog.showModal();dialog.addEventListener('close',()=>link.focus(),{once:true})}))})}initWyseTeam();document.addEventListener('shopify:section:load',e=>initWyseTeam(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wyse-release-signup"]) return;
  try {
    
if(!customElements.get('wyse-release-signup'))customElements.define('wyse-release-signup',class extends HTMLElement{
connectedCallback(){
const dialog=this.querySelector('dialog'),tab=this.querySelector('[data-release-open]');let prior;
const seen=()=>{try{return sessionStorage.getItem('wyse-release-seen')==='1'}catch{return false}};
const mark=()=>{try{sessionStorage.setItem('wyse-release-seen','1')}catch{}};
const open=()=>{if(document.querySelector('dialog[open]'))return;prior=document.activeElement;dialog.showModal();mark()};
tab.addEventListener('click',open);
this.querySelectorAll('[data-release-close]').forEach(b=>b.addEventListener('click',()=>dialog.close()));
dialog.addEventListener('close',()=>{mark();if(prior)prior.focus()});
dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
if(this.querySelector('[data-release-result],[data-release-success]'))open();
if(this.querySelector('[data-release-success]'))tab.hidden=true;
const started=Date.now();
const offer=()=>{if(seen()||Date.now()-started<35000||document.visibilityState!=='visible')return;if(document.activeElement?.matches('input,textarea,select'))return;if(scrollY>=(document.documentElement.scrollHeight-innerHeight)*.5)open()};
window.addEventListener('scroll',offer,{passive:true});setTimeout(offer,35000);
}});

  } catch(e) { console.error(e); }
})();
})();
